import {
  NspComponentProps,
  NspContainerProps,
} from '@nrdy-marketing-engine/nsp-component/@types/schema';
import HtmlContainer from '@nrdy-marketing-engine/html-container/src/html-container';
import { ComponentProps, useMemo } from 'react';
import type { HotmathPage } from '../@types/hotmath-page';

const REGEX_LEGACY_ASSETS = /="\/assets\/vt-hotmath-legacy/g;
const REGEX_HTML_LINKS = /"(\/hotmath\/[^"]+)(?:\/index)?.html"/g;
const REGEX_BREADCRUMB_TAG = /(id="hm_bread")/g;
const REGEX_IMAGES_WIITHOUT_ALT = /<img((?:(?!\balt=)[^>])+?)>/g;
const REGEX_SVG =
  /<mjx-container class="MathJax" jax="SVG"><svg style="([^"]+)" xmlns="([^"]+)" (width="[^"]+" height="[^"]+")(.+?)<\/svg><\/mjx-container>/gs;

type HtmlContainerProps = ComponentProps<typeof HtmlContainer>;

const isHtmlContainer = (component: NspComponentProps): component is HtmlContainerProps =>
  component.__typename === 'HtmlContainerRecord';

function processBodyComponents(component: NspContainerProps) {
  if (!isHtmlContainer(component)) return component;
  const host = process.env.NEXT_PUBLIC_VT_WWW_ENDPOINT;

  return {
    ...component,
    content: component.content
      .replace(REGEX_LEGACY_ASSETS, `="${host}/assets/vt-hotmath-legacy`)
      .replace(REGEX_HTML_LINKS, '"$1"')
      .replace(REGEX_BREADCRUMB_TAG, '$1 class="-mt-8 md:-mt-12 xl:-mt-18 mb-8"')
      .replace(REGEX_IMAGES_WIITHOUT_ALT, '<img$1 alt="Math diagram">')
      .replace(
        REGEX_SVG,
        (_match, style, xmlns, widthHeight, content) =>
          `<img style="${style}" alt="Math formula" class="m-0 inline-block" src="data:image/svg+xml,${encodeURIComponent(
            `<svg xmlns="${xmlns}" ${widthHeight} ${content}></svg>`
          )}"/>`
      ),
  };
}

/**
 * Receives a hotmathPage from NSP data and returns the page modified to work for Hotmath.
 */
export default function useHotmathHelpPage(hotmathPage: HotmathPage): HotmathPage {
  return useMemo<HotmathPage>(
    () => ({
      ...hotmathPage,
      body: hotmathPage.body.map(processBodyComponents),
    }),
    [hotmathPage]
  );
}
